<template>
  <section
    id="dashboard-ecommerce"
    class="dashboard-scale"
  >
    <b-row class="match-height">
      <b-col
        md="12"
        class="align-content-center"
      >
        <ticket-statistics
          :data="statisticsData"
          :last-updated-at="statisticsLastUpdated"
          queue="tickets"
          @refresh="fetchStatusStatistics"
        />
      </b-col>
    </b-row>
    <b-row class="match-height">
      <!-- Citywise Statistic card -->
      <b-col
        md="12"
      >
        <TicketByBranch
          title="Tickets By Branch"
          :data="TicketByBranchData"
          :last-updated-at="branchLastUpdated"
          queue="tickets"
          chart-color="#96A6FF"
          @refresh="fetchTicketsByBranch"
        />
      </b-col>
      <!--/ Revenue Report Card -->
    </b-row>
    <b-row class="match-height">
      <b-col
        md="6"
      >
        <TicketTrends
          title="Ticket By Trend"
          :data="TicketTrendsdata"
          :last-updated-at="trendsLastUpdated"
          queue="tickets"
          @refresh="fetchTicketTrends"
        />
      </b-col>
      <b-col
        md="6"
      >
        <TicketByMerchant
          title="Ticket By Merchant"
          :data="TicketByMerchantData"
          :last-updated-at="merchantLastUpdated"
          queue="tickets"
          @refresh="fetchTicketByMerchant"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        md="6"
      >
        <TicketByAssignee
          title="Ticket By Assignee"
          :data="TicketByAssigneeData"
          :last-updated-at="assigneeLastUpdated"
          queue="tickets"
          @refresh="fetchTicketByAssignee"
        />
      </b-col>

      <b-col
        md="6"
      >
        <div
          v-if="!isDeliveredFailedLoading"
        >
          <TicketByCategories
            title="Ticket By Categories"
            :data="TicketByCategoriesData"
            :last-updated-at="categoriesLastUpdated"
            queue="tickets"
            @refresh="fetchTicketByCategories"
          />
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import moment from 'moment'
// import BCardCode from '@core/components/b-card-code'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import TicketStatistics from '@/components/TicketDashboard/TicketStatistics.vue'
import TicketByMerchant from '@/components/TicketDashboard/TicketByMerchant.vue'
import TicketTrends from '@/components/TicketDashboard/TicketTrends.vue'
import TicketByBranch from '@/components/TicketDashboard/TicketByBranch.vue'
import TicketByCategories from '@/components/TicketDashboard/TicketByCategories.vue'
import TicketByAssignee from '@/components/TicketDashboard/TicketByAssignee.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const ticketRepository = RepositoryFactory.get('ticket')

export default {
  components: {
    TicketByBranch,
    BRow,
    BCol,
    TicketStatistics,
    TicketByMerchant,
    TicketTrends,
    TicketByCategories,
    TicketByAssignee,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      mainDashboard: {
        orderStatsData: {},
        financialStatsData: {},
        monthlyOrdersData: {},
        monthlyEarningsData: {},
        toBeInvoicesData: {},
        deliveredFailedData: {},
        MerchantOnBoardingData: {},
        statusStatisticsData: {},
        cityWiseStatsData: {},
        groupedBarChartData: {},
      },
      lastUpdated: null,
      branchLastUpdated: null,
      merchantLastUpdated: null,
      assigneeLastUpdated: null,
      trendsLastUpdated: null,
      categoriesLastUpdated: null,
      statisticsLastUpdated: null,
      TicketByBranchData: {
        categories: {
          lables: [],
        },
        series: [
          {
            name: 'Tickets Count',
            data: [],
          },
        ],
      },
      statisticsData: [],
      TicketByMerchantData: {
        categories: {
          lables: [],
        },
        series: [
          {
            name: 'Tickets',
            data: [],
          },
        ],
      },
      TicketByAssigneeData: {
        categories: {
          lables: [],
        },
        series: [
          {
            name: 'Tickets',
            data: [],
          },
        ],
      },
      TicketTrendsdata: {
        categories: {
          lables: [],
        },
        series: [
          {
            name: 'Tickets',
            data: [],
          },
        ],
      },
      TicketByCategoriesData: {
        labels: [],
        series: [],
      },
      tempdata: {
        chartData: {
          series: [
            {
              name: 'Forecasted',
              data: [],
            },
            {
              name: 'Actual Success',
              data: [],
            },
            {
              name: 'Actual Fail',
              data: [],
            },
          ],
        },
        statisticsItems: [
          {
            icon: 'BoxIcon',
            customClass: '',
            color: '#96CCFF',
            iconColor: '#0882F2',
            title: 0,
            subtitle: 'Orders Count',
            bgcolor: '#E8ECFF',
          },
          {
            icon: 'DollarSignIcon',
            customClass: 'ml-3',
            color: '#9EFF96',
            iconColor: '#15C006',
            title: 0,
            subtitle: 'Delivery Charge',
            bgcolor: '#E5F8ED',
          },
        ],
        financialstatisticsItems: [
          {
            icon: 'ShoppingBagIcon',
            customClass: '',
            color: '#96F2FF',
            iconColor: '#01AFC7',
            bgcolor: '#E0F9FC',
            title: 0,
            subtitle: 'Invoice Value',
          },
          {
            icon: 'LoaderIcon',
            customClass: '',
            color: '#FFAF96',
            iconColor: '#FB450B',
            bgcolor: '#FFF3E8',
            title: 0,
            subtitle: 'Pending Invoice',
          },
          {
            icon: 'CheckCircleIcon',
            customClass: '',
            color: '#96FFA0',
            iconColor: '#00D315',
            bgcolor: '#E5F8ED',
            title: 0,
            subtitle: 'Paid Invoice Value',
          },
          {
            icon: 'UserCheckIcon',
            customClass: '',
            color: '#96A6FF',
            iconColor: '#0026F6',
            bgcolor: '#E0F3FF',
            title: 0,
            subtitle: 'Approved Invoice',
          },
        ],
        monthlyEarnings: {
          categories:
              { lables: [] },
          series: [
            {
              name: 'Delivery Charge',
              data: [],
            },
          ],
        },
        toBeInvoices: [
          {
            avatarVariant: '#F6F0E4',
            iconColor: '#B7914D',
            avatar: 'CodesandboxIcon',
            mode: 'Collected COD',
            bgcolor: '#FFF9ED',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
          {
            avatarVariant: '#D6FCE7',
            iconColor: '#3A6A50',
            avatar: 'TruckIcon',
            mode: 'Delivery Charge',
            bgcolor: '#E5FFF1',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
          {
            avatarVariant: '#D8E8F1',
            iconColor: '#323D5A',
            avatar: 'PercentIcon',
            mode: 'Commission',
            bgcolor: '#EDF4FB',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
          {
            avatarVariant: '#E2D2F0',
            iconColor: '#473C51',
            avatar: 'DollarSignIcon',
            mode: 'Invoice Value',
            bgcolor: '#F8F1FF',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
        ],
        monthlyOrders: {
          categories:
            { lables: [] },
          series: [
            { data: [] },
          ],
        },
        clientOnBoarded: {
          categories:
              { lables: [] },
          series: [
            {
              name: 'Merchants',
              data: [],
            },
          ],
        },
        companyTable: {
          data: [],
        },
        deliveredFailed: {
          series: [45, 25, 20, 10],
        },
        cityWiseStats: {
          categories:
              { lables: [] },
          series: [
            {
              name: 'Delivered orders',
              data: [],
            },
          ],
        },
      },
      widgetConfig: {
        'finance-statistics': { fetcher: 'readDataforFinancialStats', dataProp: 'financialStatsData' },
        'monthly-orders': { fetcher: 'readDataforMonthlyOrders', dataProp: 'monthlyOrdersData' },
        'monthly-earnings': { fetcher: 'readDataforMonthlyEarnings', dataProp: 'monthlyEarningsData' },
        'to-be-invoice': { fetcher: 'readDataforToBeInvoices', dataProp: 'toBeInvoicesData' },
        'merchant-onboarding': { fetcher: 'readDataforMerchantOnBoarding', dataProp: 'MerchantOnBoardingData' },
        // 'dsr-kpi':               { fetcher: 'readDataForDSRKPI',            dataProp: 'groupedBarChartData' },
        'citywise-stats': { fetcher: 'readDataforCitywiseStats', dataProp: 'cityWiseStatsData' },
        'status-statistics': { fetcher: 'readDataforOrderStats', dataProp: 'orderStatsData' },
      },
    }
  },
  mounted() {
    this.fetchStatusStatistics()
    this.fetchTicketsByBranch({ limit: 10 })
    this.fetchTicketTrends()
    this.fetchTicketByMerchant({ limit: 10 })
    this.fetchTicketByAssignee({ limit: 10 })
    this.fetchTicketByCategories()

    this.$root.$on('refreshTicketDashboard', this.refreshAllWidgets)
  },
  beforeDestroy() {
    this.$root.$off('refreshTicketDashboard', this.refreshAllWidgets)
  },
  methods: {
    refreshAllWidgets() {
      this.fetchStatusStatistics()
      this.fetchTicketTrends()
      this.fetchTicketByCategories()
      const timestampsObj = JSON.parse(localStorage.getItem('ticketDashboardLastUpdatedAt')) || {}

      for (let i = 0; i < this.$children.length; i += 1) {
        const childComponent = this.$children[i]
        if (typeof childComponent.refreshWidget === 'function') {
          childComponent.lastRefreshTime = Date.now()

          const tag = (childComponent.$vnode && childComponent.$vnode.componentOptions && childComponent.$vnode.componentOptions.tag) || ''
          let key = childComponent.title
          if (tag.toLowerCase() === 'ticket-statistics' || tag.toLowerCase() === 'ticketstatistics') key = 'Statistics'
          if (tag.toLowerCase() === 'tickettrends' || tag.toLowerCase() === 'ticket-trends') key = 'Trend'
          if (tag.toLowerCase() === 'ticketbycategories' || tag.toLowerCase() === 'ticket-by-categories') key = 'Categories'

          if (key) {
            timestampsObj[key] = childComponent.lastRefreshTime
          }

          childComponent.$emit('refresh', { queue: childComponent.queue, limit: childComponent.perPage ? childComponent.perPage.value : 10 })
        }
      }

      localStorage.setItem('ticketDashboardLastUpdatedAt', JSON.stringify(timestampsObj))
    },
    currentDate() {
      const current = new Date()
      return `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`
    },
    async fetchStatusStatistics() {
      try {
        const { data } = await ticketRepository.getTicketStatusStatistics()
        const stats = data.data
        const total = stats.reduce((acc, curr) => acc + curr.count, 0)

        const statusMap = {
          open: {
            subtitle: 'Open Tickets', icon: 'ExternalLinkIcon', color: '#2B6BFF', bgcolor: '#EAF2FF',
          },
          assigned: {
            subtitle: 'Assigned Tickets', icon: 'UserCheckIcon', color: '#FF9F43', bgcolor: '#FFF4E6', avatarBg: '#FEE6CB',
          },
          in_progress: {
            subtitle: 'In Progress', icon: 'FileTextIcon', color: '#28C76F', bgcolor: '#E9F9F1', avatarBg: '#CBF7E2',
          },
          pending: {
            subtitle: 'Pending Tickets', icon: 'LoaderIcon', color: '#A66DD4', bgcolor: '#F3E8FF',
          },
          on_hold: {
            subtitle: 'Hold Tickets', icon: 'PauseCircleIcon', color: '#FFB800', bgcolor: '#FFF8E1', avatarBg: '#FFE082',
          },
          closed: {
            subtitle: 'Closed Tickets', icon: 'CheckCircleIcon', color: '#7367F0', bgcolor: '#EEF2FF',
          },
        }

        const result = [
          {
            title: total,
            subtitle: 'Total Tickets',
            icon: 'TagIcon',
            color: '#D81B60',
            iconColor: '#D81B60',
            bgcolor: '#FCEAEF',
            avatarBg: '#F8D7E3',
          },
        ]

        const statusOrder = ['open', 'assigned', 'in_progress', 'on_hold', 'pending', 'closed']
        statusOrder.forEach(statusKey => {
          const item = stats.find(s => s.status === statusKey)
          if (item && statusMap[statusKey]) {
            result.push({
              title: item.count,
              subtitle: statusMap[statusKey].subtitle,
              icon: statusMap[statusKey].icon,
              color: statusMap[statusKey].color,
              iconColor: statusMap[statusKey].color,
              bgcolor: statusMap[statusKey].bgcolor,
              avatarBg: statusMap[statusKey].avatarBg || statusMap[statusKey].bgcolor.replace('F', 'E').replace('E', 'D'), // Simple darkening logic
            })
          }
        })

        this.statisticsData = result
        this.statisticsLastUpdated = new Date().toISOString()
        this.lastUpdated = new Date().toISOString()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchTicketsByBranch(payload) {
      try {
        const limit = payload && payload.limit ? payload.limit : null
        const { data } = await ticketRepository.getTicketByBranch(limit)
        const branchData = data.data

        this.TicketByBranchData = {
          series: [
            {
              name: 'Tickets Count',
              data: branchData.map(item => item.count),
            },
          ],
          categories: {
            lables: branchData.map(item => item.warehouse_name.replace(' Branch', '')),
            is_agent: branchData.map(item => item.is_agent),
          },
        }
        this.branchLastUpdated = new Date().toISOString()
        this.lastUpdated = new Date().toISOString()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchTicketTrends() {
      try {
        const { data } = await ticketRepository.getTicketByDate()
        const trendsData = data.data
        const counts = trendsData.map(item => item.count)
        const labels = trendsData.map(item => moment(item.month).format("MMM 'YY"))

        // Add 3 future months with 0 values to extend the axis
        if (trendsData.length > 0) {
          const lastMonthDate = trendsData[trendsData.length - 1].month
          for (let i = 1; i <= 3; i += 1) {
            labels.push(moment(lastMonthDate).add(i, 'months').format("MMM 'YY"))
            counts.push(0)
          }
        }

        this.TicketTrendsdata = {
          series: [
            {
              name: 'Tickets',
              data: counts,
            },
          ],
          categories: {
            lables: labels,
          },
        }
        this.trendsLastUpdated = new Date().toISOString()
        this.lastUpdated = new Date().toISOString()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchTicketByMerchant(payload) {
      try {
        const limit = payload && payload.limit ? payload.limit : null
        const { data } = await ticketRepository.getTicketByMerchant(limit)
        const merchantData = data.data

        this.TicketByMerchantData = {
          series: [
            {
              name: 'Tickets',
              data: merchantData.map(item => item.count),
            },
          ],
          categories: {
            lables: merchantData.map(item => item.merchant_name),
          },
        }
        this.merchantLastUpdated = new Date().toISOString()
        this.lastUpdated = new Date().toISOString()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchTicketByAssignee(payload) {
      try {
        const limit = payload && payload.limit ? payload.limit : null
        const { data } = await ticketRepository.getTicketByAssignee(limit)
        const assigneeData = data.data

        this.TicketByAssigneeData = {
          series: [
            {
              name: 'Tickets',
              data: assigneeData.map(item => item.count),
            },
          ],
          categories: {
            lables: assigneeData.map(item => item.staff_name),
          },
        }
        this.assigneeLastUpdated = new Date().toISOString()
        this.lastUpdated = new Date().toISOString()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchTicketByCategories() {
      try {
        const { data } = await ticketRepository.getTicketByType()
        const categoriesData = data.data

        this.TicketByCategoriesData = {
          series: categoriesData.map(item => Number(item.count)),
          labels: categoriesData.map(item => item.type),
        }
        this.categoriesLastUpdated = new Date().toISOString()
        this.lastUpdated = new Date().toISOString()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>

<style lang="scss">
@import '../@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '../@core/scss/vue/libs/chart-apex.scss';
.kpi-dashboard-alert .alert {
  line-height: 30px;
}
.dashboard-scale {
  zoom: 0.8;
}
</style>
